import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Config from "../Config.json";
import { useNavigate, useLocation } from "react-router-dom";

import { useTranslation } from "react-i18next";

const Learning = () => {
  const TITLE = Config.SITE_TITLE + " | AITools";
  const DESC = "Create a React App from an HTML Website.";
  const CANONICAL = Config.SITE_DOMAIN + "/";

  const { t } = useTranslation(); // használjuk a useTranslation hookot a fordításhoz
  const navigate = useNavigate();
  const location = useLocation();
  const language = location.pathname.split("/")[1]; // Extracts language from URL

  const [filteredArticles, setFilteredArticles] = useState([]);
  const [counters, setCounters] = useState({});

  const calculateElapsedTime = (timeString) => {
    const publicationDate = new Date(timeString);
    const now = new Date();
    const diffInMs = now - publicationDate;

    const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInMinutes < 60) {
      return `${diffInMinutes} minutes ago`;
    } else if (diffInHours < 24) {
      return `${diffInHours} hours ago`;
    } else {
      return `${diffInDays} days ago`;
    }
  };

  useEffect(() => {
    const fetchArticles = async () => {
      console.log(
        `Fetching articles with language: ${language} and category: 2`
      );
      // Log to file (if applicable in the environment)
      fetch("/log", {
        method: "POST",
        body: JSON.stringify({ language, category: 2 }),
      });
      /*const articles = await getArticles("Machine Learning", language);
      const filtered = articles.filter((article) => article.category === 2); // Use numeric category (2 for Machine Learning)
      setFilteredArticles(filtered);*/
    };

    fetchArticles();
  }, [language]);

  useEffect(() => {
    const storedCounters = localStorage.getItem("articleCounters");
    if (storedCounters) {
      setCounters(JSON.parse(storedCounters));
    } else {
      const initialCounters = {};
      filteredArticles.forEach((article) => {
        initialCounters[article.ID] = { likes: 0, dislikes: 0 };
      });
      setCounters(initialCounters);
    }
  }, [filteredArticles]);

  useEffect(() => {
    if (Object.keys(counters).length > 0) {
      localStorage.setItem("articleCounters", JSON.stringify(counters));
    }
  }, [counters]);

  const handleLike = (articleId) => {
    setCounters((prevCounters) => ({
      ...prevCounters,
      [articleId]: {
        likes: (prevCounters[articleId]?.likes || 0) + 1,
        dislikes: prevCounters[articleId]?.dislikes || 0,
      },
    }));
  };

  const handleDislike = (articleId) => {
    setCounters((prevCounters) => ({
      ...prevCounters,
      [articleId]: {
        likes: prevCounters[articleId]?.likes || 0,
        dislikes: (prevCounters[articleId]?.dislikes || 0) + 1,
      },
    }));
  };

  const handleReadMore = (articleId) => {
    navigate("/article", { state: { articleId } });
  };

  return (
    <main className="main-content">
      <Helmet>
        <title>{TITLE}</title>
        <link rel="canonical" href={CANONICAL}></link>
        <meta name="description" content={DESC} />
        <meta name="theme-color" content={Config.THEME_COLOR} />
      </Helmet>
      <button id="TopBtn" title="Go to top" style={{ display: "none" }}>
        &#10224;
      </button>
      <div className="container ai-container">
        <div className="row">
          {/* Category buttons */}
          <div className="col mt-3"></div>

          {/* Display filtered articles in two responsive columns */}
          <div className="col-12">
            {/* Dynamic title based on selected category */}

            <div>
              <h2>
                <b>{t("MLTitle")}</b>
              </h2>{" "}
              <h3>
                <b>{t("MLh31")}</b>
              </h3>{" "}
              <p>{t("MLp1")}</p>{" "}
              <h3>
                <b>{t("MLh32")}</b>
              </h3>{" "}
              <p>{t("MLp2")}</p>
              <ul>
                <li>
                  <b>{t("MLli11")}</b>
                  {t("MLli111")}
                </li>
                <li>
                  <b>{t("MLli12")}</b>
                  {t("MLli121")}
                </li>
                <li>
                  <b>{t("MLli13")}</b>
                  {t("MLli131")}
                </li>
                <li>
                  <b>{t("MLli14")}</b>
                  {t("MLli141")}
                </li>
                <li>
                  <b>{t("MLli15")}</b>
                  {t("MLli151")}
                </li>
              </ul>
              <h3>
                <b>{t("MLh33")}</b>
              </h3>
              <h4>
                <b>{t("MLh41")}</b>
              </h4>{" "}
              <ul>
                <li>
                  <b>{t("MLli16")}</b>
                  {t("MLli161")}
                </li>
                <li>
                  <b>{t("MLli17")}</b>
                  {t("MLli171")}
                </li>
              </ul>
              <h4>
                <b>{t("MLh42")}</b>
              </h4>{" "}
              <ul>
                <li>
                  <b>{t("MLli18")}</b>
                  {t("MLli181")}
                </li>
                <li>
                  <b>{t("MLli19")}</b>
                  {t("MLli191")}
                </li>
              </ul>
              <h4>
                <b>{t("MLh43")}</b>
              </h4>{" "}
              <ul>
                <li>
                  <b>{t("MLli20")}</b>
                  {t("MLli201")}
                </li>
                <li>
                  <b>{t("MLli21")}</b>
                  {t("MLli211")}
                </li>
              </ul>
              <h4>
                <b>{t("MLh44")}</b>
              </h4>{" "}
              <ul>
                <li>
                  <b>{t("MLli22")}</b>
                  {t("MLli221")}
                </li>
                <li>
                  <b>{t("MLli23")}</b>
                  {t("MLli231")}
                </li>
              </ul>
              <h4>
                <b>{t("MLh45")}</b>
              </h4>
              <ul>
                <li>
                  <b>{t("MLli24")}</b>
                  {t("MLli241")}
                </li>
                <li>
                  <b>{t("MLli25")}</b>
                  {t("MLli251")}
                </li>
              </ul>
              <h4>
                <b>{t("MLh46")}</b>
              </h4>
              <ul>
                <li>
                  <b>{t("MLli26")}</b> {t("MLli261")}
                </li>
                <li>
                  <b>{t("MLli27")}</b> {t("MLli271")}
                </li>
              </ul>
              <h4>
                <b>{t("MLh47")}</b>
              </h4>{" "}
              <p dangerouslySetInnerHTML={{ __html: t("MLp3") }}></p>
            </div>
            <div className="row g-3">
              {filteredArticles.map((article) => (
                <div className="col-sm-12 col-md-6 col-lg-4" key={article.ID}>
                  <div className="card h-100">
                    <img
                      src={article.img}
                      className="card-img-top"
                      alt={article.alt}
                    />
                    <div className="card-body">
                      <h5 className="card-title">{article.title}</h5>
                      <p className="card-text text-truncate">
                        {article.teaser}
                      </p>
                      <p className="text-muted">
                        Published: {calculateElapsedTime(article.time)}
                      </p>
                      <div className="d-flex justify-content-between">
                        <button
                          className="btn btn-outline-success btn-sm"
                          onClick={() => handleLike(article.ID)}
                        >
                          👍 {counters[article.ID]?.likes || 0}
                        </button>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          onClick={() => handleDislike(article.ID)}
                        >
                          👎 {counters[article.ID]?.dislikes || 0}
                        </button>
                      </div>
                      <button
                        onClick={() => handleReadMore(article.ID)}
                        className="btn btn-AIinsideLife-primary w-100 mt-2"
                      >
                        Read More...
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Learning;
